import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [guidesDropdownOpen, setGuidesDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mobileGuidesOpen, setMobileGuidesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const guidesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
      if (guidesRef.current && !guidesRef.current.contains(e.target as Node)) {
        setGuidesDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20aerial%20flat%20lay%20of%20diverse%20fashion%20products%20shoes%20bags%20accessories%20arranged%20in%20elegant%20spiral%20pattern%20on%20textured%20cream%20linen%20surface%2C%20soft%20diffused%20overhead%20light%2C%20editorial%20catalog%20aesthetic%2C%20muted%20earth%20tones%20terracotta%20sage%20sand%20with%20subtle%20metallic%20accents%2C%20organized%20yet%20organic%20composition%2C%20sophisticated%20brand%20lookbook%20style&width=1920&height=1080&seq=hero-bg-v2-2026&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35" />

      <nav
        className={`relative z-50 w-full transition-all duration-300 ${
          scrolled
            ? 'fixed top-0 bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="/"
            className={`text-xl md:text-2xl font-heading font-bold whitespace-nowrap ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            hipobuyspread<span className="text-accent-400">.org</span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            <a
              href="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              Home
            </a>

            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors ${
                  scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
                }`}
              >
                Categories
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full mt-2 left-0 w-56 bg-background-50 rounded-lg border border-background-200/70 shadow-lg py-2 z-50 max-h-80 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.seq}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div ref={guidesRef} className="relative">
              <button
                onClick={() => setGuidesDropdownOpen(!guidesDropdownOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors ${
                  scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
                }`}
              >
                Guides
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${guidesDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {guidesDropdownOpen && (
                <div className="absolute top-full mt-2 left-0 w-56 bg-background-50 rounded-lg border border-background-200/70 shadow-lg py-2 z-50 max-h-80 overflow-y-auto">
                  <Link
                    to="/hipobuy-spreadsheet-guide"
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                    onClick={() => setGuidesDropdownOpen(false)}
                  >
                    Hipobuy Spreadsheet Guide
                  </Link>
                  <Link
                    to="/kakobuy-spreadsheet-guide"
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                    onClick={() => setGuidesDropdownOpen(false)}
                  >
                    Kakobuy Spreadsheet Guide
                  </Link>
                  <Link
                    to="/cssbuy-spreadsheet-guide"
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                    onClick={() => setGuidesDropdownOpen(false)}
                  >
                    CSSBuy Spreadsheet Guide
                  </Link>
                  <Link
                    to="/superbuy-spreadsheet-guide"
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                    onClick={() => setGuidesDropdownOpen(false)}
                  >
                    Superbuy Spreadsheet Guide
                  </Link>
                  <Link
                    to="/oopbuy-spreadsheet-guide"
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                    onClick={() => setGuidesDropdownOpen(false)}
                  >
                    Oopbuy Spreadsheet Guide
                  </Link>
                </div>
              )}
            </div>

            <a
              href="#about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              About
            </a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-white/20 text-white border border-white/30 hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              Hipobuy Sheet
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            <i className={mobileMenuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-5 space-y-4 max-h-[80vh] overflow-y-auto">
            <Link to="/" className="flex items-center gap-3 py-3 text-foreground-700 font-semibold text-sm" onClick={() => setMobileMenuOpen(false)}>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50"><i className="ri-home-4-line text-primary-600"></i></span>
              Home
            </Link>

            <div>
              <button
                onClick={() => setMobileGuidesOpen(!mobileGuidesOpen)}
                className="flex items-center justify-between w-full py-3 text-foreground-700 font-semibold text-sm"
              >
                <span className="flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-50"><i className="ri-article-line text-accent-600"></i></span>
                  SEO Guides
                </span>
                <i className={`ri-arrow-down-s-line transition-transform duration-200 text-foreground-400 ${mobileGuidesOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {mobileGuidesOpen && (
                <div className="ml-11 space-y-1 pb-2">
                  <Link to="/hipobuy-spreadsheet-guide" className="flex items-center gap-2 py-2.5 px-3 text-sm text-foreground-600 hover:text-primary-700 rounded-md transition-colors" onClick={() => setMobileMenuOpen(false)}>
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-400 flex-shrink-0"></span>
                    Hipobuy Spreadsheet Guide
                  </Link>
                  <Link to="/kakobuy-spreadsheet-guide" className="flex items-center gap-2 py-2.5 px-3 text-sm text-foreground-600 hover:text-primary-700 rounded-md transition-colors" onClick={() => setMobileMenuOpen(false)}>
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0"></span>
                    Kakobuy Spreadsheet Guide
                  </Link>
                  <Link to="/cssbuy-spreadsheet-guide" className="flex items-center gap-2 py-2.5 px-3 text-sm text-foreground-600 hover:text-primary-700 rounded-md transition-colors" onClick={() => setMobileMenuOpen(false)}>
                    <span className="w-1.5 h-1.5 rounded-full bg-secondary-400 flex-shrink-0"></span>
                    CSSBuy Spreadsheet Guide
                  </Link>
                  <Link to="/superbuy-spreadsheet-guide" className="flex items-center gap-2 py-2.5 px-3 text-sm text-foreground-600 hover:text-primary-700 rounded-md transition-colors" onClick={() => setMobileMenuOpen(false)}>
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-300 flex-shrink-0"></span>
                    Superbuy Spreadsheet Guide
                  </Link>
                  <Link to="/oopbuy-spreadsheet-guide" className="flex items-center gap-2 py-2.5 px-3 text-sm text-foreground-600 hover:text-primary-700 rounded-md transition-colors" onClick={() => setMobileMenuOpen(false)}>
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-300 flex-shrink-0"></span>
                    Oopbuy Spreadsheet Guide
                  </Link>
                </div>
              )}
            </div>

            <div>
              <p className="text-[10px] text-foreground-400 font-semibold uppercase tracking-widest px-1 pb-3">Shop by Category</p>
              <div className="grid grid-cols-2 gap-1.5">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 py-2.5 px-2.5 text-xs text-foreground-600 hover:bg-primary-50 hover:text-primary-700 rounded-lg transition-colors bg-background-100/70"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded bg-background-200/60">
                      <i className="ri-arrow-right-up-line text-[10px] text-foreground-400"></i>
                    </span>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="space-y-2 pt-3 border-t border-background-200/60">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold"
              >
                <i className="ri-shopping-cart-line"></i>
                Buy It Now
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full py-3 bg-background-100 border border-background-200/60 text-foreground-700 rounded-full text-sm font-medium"
              >
                <i className="ri-external-link-line"></i>
                Hipobuy Sheet
              </a>
            </div>
          </div>
        )}
      </nav>

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 md:px-6 text-center w-full">
        <div className="max-w-3xl w-full">
          <p className="text-white/70 text-xs md:text-sm font-label tracking-widest uppercase mb-4">
            Your Shopping Intelligence Platform
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
            Hipobuy Spreadsheet
          </h1>
          <p className="text-lg md:text-2xl font-body font-light text-white/90 mb-2">
            The Ultimate Product Discovery &amp; Shopping Guide
          </p>
          <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto mb-10">
            Discover the latest Hipobuy Spreadsheet resources, product lists, QC guides, category comparisons, and verified shopping information.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-semibold whitespace-nowrap hover:bg-white/30 transition-all"
            >
              Hipobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold whitespace-nowrap hover:bg-accent-600 transition-all"
            >
              Buy It Now
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-white/80 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i> Updated Resources
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i> Shopping Research Guides
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i> Safety Information
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-400"></i> Category Comparisons
            </span>
          </div>
        </div>
      </div>

      <div className="relative z-10 pb-8 flex justify-center">
        <a href="#categories" className="animate-bounce text-white/60 hover:text-white transition-colors">
          <i className="ri-arrow-down-s-line text-3xl"></i>
        </a>
      </div>
    </section>
  );
}